/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'GoalPanel.header.title': 'Goal',
  'goal-panel.generic-error.description': 'Please check your internet connection and try again.',
  'goal-panel.generic-error.title': 'Something went wrong',
  'goal-panel.goal-panel-expand-field-button.show-less-collapsed-label': 'Show more fields',
  'goal-panel.goal-panel-expand-field-button.show-more-collapsed-label': 'Show less',
  'goal-panel.goal-panel-tabs.about-tab-title': 'About',
  'goal-panel.goal-panel-tabs.jira-align-title': 'Jira Align',
  'goal-panel.goal-panel-tabs.jira-title': 'Jira',
  'goal-panel.goal-panel-tabs.projects-title': 'Projects',
  'goal-panel.goal-panel-tabs.updates-tab-title': 'Updates',
  'goal-panel.goal-title.edit-button-label': 'Edit goal title',
  'goal-panel.goal-title.update-error-description': 'Could not update the content for {goalName}',
  'goal-panel.goal-title.update-error-title': 'Something went wrong',
  'goal-panel.goal-title.validation-message': 'Please specify a title for your goal',
};
